import * as batshit from "@yornaath/batshit";
import api from "../../../api";
import {UnderstandingId, EngagementId, ProcessStepId, UnderstandingSummaryEvidenceId} from "platformed-client/types";
import {param, typedQuery} from "../../typing";
import {resolver, scheduler} from "../../batch";

export const engagementUnderstandings = typedQuery(
  ["tprm", "engagementUnderstandings", param<EngagementId>("engagementId")],
  async engagementId => {
    return await api.tprm.engagements.listUnderstandings(engagementId);
  },
);

export const understanding = typedQuery(
  ["tprm", "understanding", param<UnderstandingId>("understandingId")],
  async understandingId => {
    return await api.tprm.understandings.get(understandingId);
  },
);

export const understandingDiagrams = typedQuery(
  ["tprm", "understandingDiagrams", param<UnderstandingId>("understandingId")],
  async understandingId => {
    return await api.tprm.understandings.listDiagrams(understandingId);
  },
);

const summaryEvidencesById = batshit.create({
  fetcher: api.tprm.understandings.loadSummaryEvidence,
  resolver: resolver("understanding_summary_evidence_id"),
  scheduler,
});

export const summaryEvidenceById = typedQuery(
  ["tprm", "summaryEvidenceById", param<UnderstandingSummaryEvidenceId>("evidenceId")],
  async evidenceId => {
    return await summaryEvidencesById.fetch(evidenceId);
  },
);

export const understandingSummaryEvidence = typedQuery(
  ["tprm", "understandingSummaryEvidence", param<UnderstandingId>("understandingId")],
  async understandingId => {
    return await api.tprm.understandings.listSummaryEvidence(understandingId);
  },
);

export const understandingSteps = typedQuery(
  ["tprm", "understandingSteps", param<UnderstandingId>("understandingId")],
  async understandingId => {
    return await api.tprm.understandings.listSteps(understandingId);
  },
);

export const processStepActivity = typedQuery(
  ["tprm", "processStepActivity", param<UnderstandingId>("understandingId"), param<ProcessStepId>("processStepId")],
  async (understandingId, processStepId) => {
    return await api.tprm.understandings.listStepActivity(understandingId, processStepId);
  },
);
